// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"404":"442d184c","683":"62e9939c","711":"4b514179"}[chunkId] + ".chunk.css";
};